import { Modal } from "react-bootstrap"

const DialogModal = ({show, setShow, title, text, onSubmit, loader}) => {
    return(
        <Modal show={show} onHide={() => setShow()}>
            <Modal.Header><h3 className="dialog-modal-text">{title}</h3></Modal.Header>
            <Modal.Body><span className="dialog-modal-text">{text}</span></Modal.Body>
            <Modal.Footer>
                <div className="modal-action-buttons">
                    <button type="submit" onClick={onSubmit} disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : "Yes"}</button>
                    <button type="button" onClick={() => setShow(false)} className="cancel-modal-form-btn">No</button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default DialogModal